var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarshallIsland(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.384 512 512 397.384 512 256C512 213.037 501.4 172.554 482.698 137L255.699 256.3L375 29.302C339.446 10.6 298.963 0 256 0C114.616 0 0 114.616 0 256C0 326.693 28.654 390.693 74.98 437.02C121.307 483.347 185.307 512 256 512Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.428 137.279C470.71 114.975 455.475 94.0342 436.721 75.2802C417.966 56.5262 397.028 41.2912 374.722 29.5742L74.6809 437.319L482.428 137.279Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6809 437.319L482.428 137.279C470.71 114.975 455.475 94.0338 436.721 75.2798L74.6809 437.319Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.308 150.122L191.044 164.828L207.693 195.108L173.743 188.613L169.441 222.909L145.793 197.684L122.145 222.909L117.845 188.613L83.8951 195.106L100.542 164.827L69.2781 150.122L100.543 135.415L83.8951 105.137L117.843 111.63L122.146 77.334L145.793 102.559L169.441 77.334L173.743 111.63L207.694 105.137L191.045 135.416L222.308 150.122Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarshallIsland);
export default __webpack_public_path__ + "static/media/marshallIsland.3c9a14302a1fa0fef7bfef2924c324d6.svg";
export { ForwardRef as ReactComponent };